import React from "react";
import { Outlet, useParams } from "react-router-dom";
//import HeaderComponent from "../components/Header/HeaderComponent";
import BoxComponent from "../components/Box/BoxComponent";
import SidebarComponent from "../components/layout/Dashboard/Sidebar/SidebarComponent";
import DashboardHeaderComponent from "../components/layout/Dashboard/Header/DashboardHeaderComponent";
import EmpresaProvider from "../provider/empresa/EmpresaProvider";

const DashboardLayout = () => {
    const heightFixo = window.location.pathname.includes("/pedidos")
    || window.location.pathname.includes("/catalogo");
    //|| window.location.pathname.includes("/caixa");

    return <EmpresaProvider>
        <BoxComponent
            sx={{
                display: "flex",
                height: "100dvh"
            }}
            component="div"
        >
            {/* <BoxComponent
                sx={{
                }}
                component="header">
                <HeaderComponent />
            </BoxComponent> */}

            <BoxComponent
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    flex: 1,
                    background: "linear-gradient(135deg, #FFFFFF 0%, #F8F5F0 100%)",
                    borderRight: "1px solid #E8DFD5"
                }}
                component="section">
                <SidebarComponent />
            </BoxComponent>

            <BoxComponent sx={{
                display: "flex",
                flexDirection: "column",
                flex: 5,
                background: "#F8F5F0"
            }} component="aside">
                <DashboardHeaderComponent />

                <BoxComponent sx={{
                    display: "flex",
                    flexDirection: "column",
                    padding: "2rem", // 32PX,
                    height: heightFixo ? "calc(100dvh - 64px)" : "auto", // POR ENQUANTO EM PEDIDOS
                    overflow: heightFixo ? "hidden" : "auto"
                }} component="main">
                    <BoxComponent sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                        height: heightFixo ? "100%" : "auto", // POR ENQUANTO EM PEDIDOS
                    }} component="div">
                        <Outlet />
                    </BoxComponent>
                </BoxComponent>
            </BoxComponent>
        </BoxComponent>
    </EmpresaProvider>
}

export default DashboardLayout;